import React from "react";

const LeftArea = ({ welcome, email }) => {
  return (
    <div className="leftArea flex flex-col gap-8">
      <div className="w-[250px] sm:w-[408px] h-[95px] relative">
        <img src="/logo.svg" alt="logo" className="w-[100%] " />
        <div className="absolute right-[-60px]">
          <img src="/Vector.svg " alt="Vector Icon" />
        </div>
      </div>
      <h1 className="text-4xl font-bold leading-10 text-left">
        {welcome ? "Hoşgeldin!" : email ? "E-mail Onay" : "Son bir adım."}
      </h1>
      <p className="text-base font-medium leading-[22px] text-left text-grayy">
        {welcome ? "Seni aramızda görmeyi çok isteriz :)" : ""}
      </p>
    </div>
  );
};

export default LeftArea;
